import { Heading, Text } from "@chakra-ui/react";
import React from "react";

const Error = () => {
  return (
    <>
      <Heading>Error</Heading>
      <Text>
        Se ha encontrado un error inesperado. Vuelva a intentarlo o contacte
        a un administrador.
      </Text>
    </>
  );
};

export default Error;
